import { Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class PFKeys extends MainKeys {
    get place() {
        return Places.mcPf
    }
}

export default PFKeys
